import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Modern Business | Internship Project by Rahul</p>
    </footer>
  );
}

export default Footer;
